// LegalHubLayout.js - Full, Complete Legal Center with ZERO Data/Content Loss
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LegalHub.css';
import Logo from '../Logo/Logo';
import GlobalFooter from '../Footer/GlobalFooter';
import { LEGAL_DOCUMENTS, legalDocumentById, legalDocumentIdForPath } from './legalDocuments';

const LegalHubLayout = ({ defaultTab = 'privacy' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTabFromLocation = () => legalDocumentIdForPath(location.pathname, defaultTab);

  const [activeTab, setActiveTab] = useState(getActiveTabFromLocation());

  useEffect(() => {
    setActiveTab(getActiveTabFromLocation());
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleTabChange = (doc) => {
    setActiveTab(doc.id);
    navigate(doc.path);
  };

  const renderActiveContent = () => {
    const doc = legalDocumentById(activeTab);
    const { Body } = doc;
    return (
      <div>
        <h1 className="legal-doc-title">{doc.heading}</h1>
        <p className="legal-effective-date">
          Effective date: {doc.effective}{doc.updated ? ` · Last updated: ${doc.updated}` : ''}
        </p>

        <Body />
      </div>
    );
  };

  return (
    <div className="legal-hub-page">
      <header className="legal-hub-header">
        <div className="legal-hub-header-container">
          <button className="legal-back-btn" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back
          </button>
          <Logo />
        </div>
      </header>

      <div className="legal-hub-body">
        {/* Left Sidebar Navigation */}
        <aside className="legal-sidebar">
          <div className="legal-sidebar-heading">Legal</div>
          <nav className="legal-sidebar-nav">
            {LEGAL_DOCUMENTS.map((doc) => (
              <button
                key={doc.id}
                onClick={() => handleTabChange(doc)}
                className={`legal-nav-link ${activeTab === doc.id ? 'active' : ''}`}
              >
                {doc.title}
              </button>
            ))}
          </nav>
        </aside>

        {/* Right Main Content */}
        <main className="legal-main-content">
          {renderActiveContent()}
        </main>
      </div>

      <GlobalFooter />
    </div>
  );
};

export default LegalHubLayout;
